/* eslint-disable complexity */
import Gikam from './gikam-core';

export function openFile(fileId, readonly, otherParam, popupIsModal) {
    if (!fileId) return;
    const supportType = [
        {
            code: 'text',
            typeArray: [
                'doc',
                'docm',
                'docx',
                'dot',
                'dotm',
                'dotx',
                'epub',
                'fodt',
                'htm',
                'html',
                'mht',
                'odt',
                'ott',
                'pdf',
                'rtf',
                'txt',
                'djvu',
                'xps'
            ]
        },
        {
            code: 'spreadsheet',
            typeArray: ['csv', 'fods', 'ods', 'ots', 'xls', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx']
        },
        {
            code: 'presentation',
            typeArray: ['fodp', 'odp', 'otp', 'pot', 'potm', 'potx', 'pps', 'ppsm', 'ppsx', 'ppt', 'pptm', 'pptx']
        }
    ];

    let typeStr = '';
    Gikam.getJson(Gikam.IFM_CONTEXT + '/core/module/item/files/' + fileId).done(file => {
        supportType.forEach(item => {
            if (item.typeArray.indexOf(file.fileExt.toLocaleLowerCase()) !== -1) {
                typeStr = item.code;
            }
        });

        let pdfView = Gikam.pdf && Gikam.pdf.view;
        if (['pdfjs', 'pdfComment'].indexOf(pdfView) > -1 && file.fileExt.toLocaleLowerCase() === 'pdf') {
            Gikam.printFile(fileId, readonly, null, null, null, popupIsModal, otherParam);
        } else if (typeStr) {
            Gikam.openOfficeFile({
                fileId: fileId,
                readonly: readonly,
                otherParam: otherParam ? otherParam : null,
                popupIsModal: popupIsModal
            });
        } else {
            Gikam.printFile(fileId, readonly, null, null, null, popupIsModal);
        }
    });
}

export function openOfficeFile(param) {
    const documentParam = {
        fileId: param.fileId,
        mode: param.readonly ? 'view' : 'edit',
        popupIsModal: param.popupIsModal
    };
    Gikam.isNotEmpty(param.otherParam)
        ? Gikam.openFileByOffice(documentParam, param.otherParam)
        : Gikam.openFileByOffice(documentParam);
}

/**
 * @description 打开office编辑页面
 * @public
 * @param {Object, Object} 编辑器参数
 * @memberof this
 */

export function openFileByOffice(options, value) {
    if (Gikam.isNotEmpty(value)) {
        options.otherParam = value;
    }
    return new Gikam.EditorOffice(options);
}

export function openOfficeFileByUrl(fileUrl) {
    return new Gikam.ViewOffice(fileUrl);
}

export function openExternalOfficeFile(options) {
    return new Gikam.CustomEditorOffice(options);
}

export function printFile(fileId, readonly, waterText, printFlag, pdfWaterFlag, popupIsModal, otherParam) {
    const pageUrl = Gikam.IFM_CONTEXT + '/core/module/item/files/page/open-file';
    const imgFile = [
        'jpg',
        'jpeg',
        'png',
        'gif',
        'svg',
        'webp',
        'bmp',
        'JPG',
        'JPEG',
        'PNG',
        'GIF',
        'SVG',
        'WEBP',
        'BMP'
    ];
    const param = {
        fileId: fileId, // 文件id
        readonly: readonly, // 是否只读，office文件只读的话不能加水印不能有打印按钮；
        waterText: Gikam.isEmpty(waterText) ? null : escape(Gikam.propI18N(waterText)), // readonly为false的时候,office文件才会加上水印,office水印内容为所传的值；pdf水印内容后台处理
        printFlag: printFlag, // readonly为
        // false的时候才执行，是否打印，文件显示打印按钮的话为true
        waterFlag: pdfWaterFlag
    };
    let url = pageUrl + Gikam.param(param);

    const pdfView = Gikam.pdf && Gikam.pdf.view;
    const videoType = ['mp4', 'rmvb', 'wmv', 'avi', 'flv', 'amv', 'mov'];

    Gikam.getConstantValue('FILESERVER_CLUSTER')
        .done(rt => {
            url += '&fileserverCluster=' + rt.constantValue;
        })
        .then(() => {
            return Gikam.getJson(Gikam.IFM_CONTEXT + '/core/module/item/files/' + fileId);
        })
        .done(file => {
            if (imgFile.indexOf(file.fileExt.toLocaleLowerCase()) > -1) {
                const modal = Gikam.create('modal', {
                    title: file.name,
                    toolbarTop: true,
                    showMaxBtn: otherParam?.showMaxBtn ?? false,
                    isModal: Gikam.isFalse(popupIsModal) ? false : true
                });
                // 特殊字符转义
                const fileUrl =
                    file.downloadUrl.substring(0, file.downloadUrl.lastIndexOf('/') + 1) +
                    encodeURIComponent(file.name);
                Gikam.create('viewer', {
                    renderTo: modal.window.$dom,
                    images: [Gikam.getFileContextUrl(fileUrl)],
                    imageRotate: otherParam?.imageRotate
                });
            } else if (videoType.indexOf(file.fileExt.toLocaleLowerCase()) > -1) {
                const modal = Gikam.create('modal', {
                    title: file.name,
                    toolbarTop: true,
                    showMaxBtn: false,
                    isModal: Gikam.isFalse(popupIsModal) ? false : true
                });
                Gikam.create('layout', {
                    renderTo: modal.window.$dom,
                    center: {
                        items: [
                            {
                                type: 'video',
                                sources: [
                                    {
                                        type: 'video/mp4',
                                        src: Gikam.getFileContextUrl(file.downloadUrl)
                                    }
                                ]
                            }
                        ]
                    }
                });
            } else if (pdfView === 'pdfComment' && file.fileExt.toLocaleLowerCase() === 'pdf') {
                if (otherParam && otherParam.viewType === 'blank') {
                    window.open(Gikam.IFM_CONTEXT + `/core/module/item/files/page/pdf-comment-blank?fileId=${file.id}`);
                } else {
                    const modal = Gikam.create('modal', {
                        title: file.name,
                        toolbarTop: true,
                        showMaxBtn: false,
                        isModal: Gikam.isFalse(popupIsModal) ? false : true
                    });
                    Gikam.create('pdfView', {
                        fileId: file.id,
                        renderTo: modal.window.$dom
                    });
                }
            } else {
                Gikam.create('modal', {
                    title: file.name,
                    iframe: true,
                    isFullScreen: true,
                    src: url,
                    isModal: Gikam.isFalse(popupIsModal) ? false : true
                });
            }
        });
}
